"use client";

import { fadeAnimation } from "@/libs/utils/animations";
import { cn } from "@/libs/utils/common";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { AnimatePresence, motion } from "motion/react";
import { ComponentPropsWithRef } from "react";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = ({ delayDuration = 300, ...props }: ComponentPropsWithRef<typeof TooltipPrimitive.Root>) => (
  <TooltipPrimitive.Root delayDuration={delayDuration} {...props} />
);
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipArrow = TooltipPrimitive.Arrow;

export function TooltipContent({
  ref,
  className,
  sideOffset = 4,
  collisionPadding = 8,
  ...props
}: ComponentPropsWithRef<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          "z-50 rounded-md bg-card text-card-fg px-3 py-1.5 text-sm animate-in fade-in-0 zoom-in-95 shadow-lg",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
          "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}

export function AnimatedToolTipContent({
  open,
  ref,
  className,
  children,
  sideOffset = 4,
  ...props
}: ComponentPropsWithRef<typeof TooltipPrimitive.Content> & { open: boolean }) {
  return (
    <AnimatePresence>
      {open && (
        <TooltipPrimitive.Portal forceMount>
          <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={cn("z-50 rounded-md bg-white text-black px-3 py-1.5 text-sm shadow-lg", className)}
            {...props}
            asChild
          >
            <motion.div {...fadeAnimation}>{children}</motion.div>
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      )}
    </AnimatePresence>
  );
}
